export const categories = [
  { slug: 'xiangchu-zhidao', name: '年轻岳母相处之道', description: '与年轻的岳母建立良好关系的实用方法与心理指南' },
  { slug: 'nvxu-yuemu', name: '女婿岳母关系', description: '女婿与岳母之间的情感边界、相处原则与深度沟通' },
  { slug: 'daiji-guanxi', name: '家庭代际关系', description: '不同代际之间的价值观碰撞、理解与融合' },
  { slug: 'yuemu-poxi', name: '岳母婆媳矛盾', description: '化解岳母与儿媳之间的潜在矛盾与冲突' },
  { slug: 'qinggan-bianjie', name: '家庭情感边界', description: '在亲密关系中建立健康的情感边界与个人空间' },
  { slug: 'goutong-jiqiao', name: '和谐家庭沟通技巧', description: '提升家庭成员间沟通效率的实用方法与技巧' },
];

export const articles = [
  {
    id: 1,
    slug: 'ruhe-yu-nianqing-yuemu-xiangchu',
    title: '如何与年轻的岳母建立良好关系：从陌生到亲密的十步法则',
    excerpt: '当岳母比你想象中更年轻时，代际差异似乎缩小了，但相处之道却需要更多的智慧与耐心。本文将为您揭示与年轻岳母建立深厚情感连接的十个关键步骤...',
    content: `
      <p>在现代家庭结构中，「年轻的岳母」这一角色越来越常见。她可能只比你大十几岁，拥有活跃的社交圈、紧跟潮流的生活方式，甚至在职场上依然充满干劲。这样的岳母既像是长辈，又像是朋友，相处起来既亲近又微妙。</p>
      <h2>第一步：放下预设，重新认识</h2>
      <p>很多人在结婚前就对「岳母」这个角色有了刻板印象——严肃、挑剔、难以取悦。但当岳母还很年轻时，这些标签往往完全不适用。她可能正在经历自己的中年转型，有自己的兴趣爱好和事业追求。试着把她当作一个独立的个体去了解，而不是「妻子的母亲」这个标签。</p>
      <h2>第二步：尊重她的「年轻状态」</h2>
      <p>年轻的岳母往往对外表、生活方式有自己的一套标准。她可能比你更注重穿着搭配，更热衷于健身旅行。不要用传统观念去评判她，而是给予真诚的赞美和尊重。一句「妈，您今天这身搭配真好看」往往能拉近不少距离。</p>
      <h2>第三步：找到共同话题</h2>
      <p>年龄差距缩小意味着你们的成长背景可能有更多重叠。问问她年轻时听的歌、看的电影，分享你最近发现的好餐厅、好剧。找到共同的兴趣点是建立情感连接最快的方式。</p>
      <h2>第四步：适度保持距离</h2>
      <p>年轻意味着她可能更愿意参与你们的生活，但这不意味着你们需要失去边界。聪明的做法是：热情但不黏腻，亲近但有分寸。每周固定时间的家庭聚餐是不错的平衡点。</p>
      <h2>第五步：用行动表达尊重</h2>
      <p>对她女儿好，这是最直接的尊重表达。让她看到你对她女儿的用心和呵护，这比任何言语都更有说服力。同时，在家庭决策中适当征求她的意见，让她感受到自己在家庭中的价值。</p>
    `,
    category: 'xiangchu-zhidao',
    categoryName: '年轻岳母相处之道',
    imageQuery: 'warm%20family%20gathering%20young%20mother%20in%20law%20smiling%20with%20son%20in%20law%20modern%20living%20room%20soft%20natural%20light%20editorial%20photography%20cozy%20atmosphere%20beige%20and%20cream%20tones%20minimalist%20interior%20genuine%20emotional%20connection',
    author: '林婉清',
    date: '2026-07-15',
    readTime: 8,
    tags: ['岳母关系', '相处技巧', '家庭和谐'],
    featured: true,
  },
  {
    id: 2,
    slug: 'nvxu-yuemu-qinggan-bianjie',
    title: '女婿与岳母的情感边界：亲密有间才是长久之道',
    excerpt: '「太近了会窒息，太远了会疏离」——如何在女婿与岳母之间找到一个恰到好处的情感距离？这篇文章从心理学角度为您深度解析...',
    content: `
      <p>在家庭关系中，女婿与岳母的关系是最容易被忽视但又最容易引发矛盾的一组关系。尤其是当岳母年轻时，这种关系的边界感更加模糊。</p>
      <h2>为什么边界感如此重要？</h2>
      <p>心理学研究表明，健康的家庭关系需要清晰的边界。没有边界的亲密会导致角色混乱、期望错位，最终伤害所有家庭成员。对于女婿而言，岳母既不是亲生母亲，也不是普通朋友，这种特殊的身份更需要明确的行为准则。</p>
      <h2>建立边界的三个原则</h2>
      <p>第一，<strong>经济独立是底线</strong>。无论岳母多么慷慨，尽量不要在经济上过度依赖她。金钱往来最容易模糊人际边界。</p>
      <p>第二，<strong>核心家庭优先</strong>。你和妻子组成的小家庭是第一位的，任何决策都应该以这个小家庭的利益为出发点，而不是优先考虑岳母的意愿。</p>
      <p>第三，<strong>情感独立但关怀</strong>。你不需要对岳母有对亲生母亲那样的情感依赖，但真诚的关心和尊重是必须的。</p>
      <h2>常见边界问题及应对</h2>
      <p>岳母频繁来访怎么办？用温柔而坚定的方式表达：「妈，这周末我们想二人世界，下周我们一定好好陪您。」关键是要让妻子站在你这边，由她来传达会更有效。</p>
    `,
    category: 'nvxu-yuemu',
    categoryName: '女婿岳母关系',
    imageQuery: 'two%20men%20having%20respectful%20conversation%20in%20bright%20modern%20apartment%20warm%20lighting%20professional%20but%20relaxed%20atmosphere%20beige%20and%20soft%20green%20tones%20editorial%20style%20clean%20composition',
    author: '陈思远',
    date: '2026-06-28',
    readTime: 6,
    tags: ['情感边界', '女婿关系', '家庭心理学'],
    featured: true,
  },
  {
    id: 3,
    slug: 'daiji-jiazhiguan-chongtu-huajie',
    title: '代际价值观冲突：当80后女婿遇上70后岳母',
    excerpt: '消费观念、育儿理念、生活方式——不同代际之间的价值观差异是家庭矛盾的主要来源。学会理解和化解这些差异，是构建和谐家庭的第一步...',
    content: `
      <p>70后的岳母和80后、90后的女婿之间，隔着的不仅是年龄，更是整个时代变迁带来的价值观鸿沟。</p>
      <h2>消费观念的碰撞</h2>
      <p>70后经历过物资相对匮乏的年代，即使现在条件好了，骨子里依然保持着节俭的习惯。而80后、90后在消费升级的环境中长大，更注重生活品质和体验消费。当岳母看到你花几百块吃一顿饭时，内心的不认同是真实存在的。</p>
      <p>应对之道：不是争辩谁对谁错，而是互相理解对方行为背后的原因。可以邀请岳母一起体验她觉得「贵」的东西，让她感受到其中的价值，而不是直接否定她的观念。</p>
      <h2>育儿理念的分歧</h2>
      <p>关于孩子能不能吹空调、要不要穿袜子、奶粉好还是母乳好——这些看似琐碎的问题，实际上是两代人育儿理念的正面交锋。</p>
      <p>解决策略：尊重科学，但也要尊重经验。用温和的方式分享最新的育儿知识，同时给岳母的「老经验」留面子。毕竟，她的出发点永远是爱孩子。</p>
    `,
    category: 'daiji-guanxi',
    categoryName: '家庭代际关系',
    imageQuery: 'three%20generations%20family%20sitting%20together%20in%20bright%20living%20room%20warm%20sunlight%20streaming%20through%20windows%20peaceful%20atmosphere%20grandmother%20daughter%20and%20grandchild%20smiling%20soft%20beige%20and%20cream%20color%20palette',
    author: '林婉清',
    date: '2026-06-10',
    readTime: 7,
    tags: ['代际冲突', '价值观', '家庭和谐'],
    featured: true,
  },
  {
    id: 4,
    slug: 'yuemu-poxi-maodun-huajie-zhinan',
    title: '岳母与儿媳：当两个女人同时爱着一个男人',
    excerpt: '岳母与儿媳之间的矛盾，本质上是两个女人对同一个男人的爱的博弈。理解这个本质，才能找到化解矛盾的正确路径...',
    content: `
      <p>在所有的家庭关系中，岳母与儿媳的关系可能是最微妙也最容易被点燃的。当岳母还年轻时，这种关系的张力往往更加明显。</p>
      <h2>矛盾的根源</h2>
      <p>根本上，岳母与儿媳都在争夺同一个男人的注意力和情感。岳母担心儿子结婚后就不再关心自己，儿媳则希望丈夫把自己放在第一位。这种潜在的竞争关系是大多数矛盾的根源。</p>
      <h2>丈夫（儿子）的关键角色</h2>
      <p>在这场关系中，丈夫是最关键的调解者。他需要在两个女人之间做好桥梁：让母亲感受到「你没有失去儿子，而是多了一个女儿」，让妻子感受到「你才是我生命中最重要的女人」。</p>
    `,
    category: 'yuemu-poxi',
    categoryName: '岳母婆媳矛盾',
    imageQuery: 'two%20women%20one%20older%20one%20younger%20having%20tea%20together%20in%20bright%20modern%20kitchen%20sunlight%20through%20window%20harmonious%20atmosphere%20soft%20warm%20tones%20editorial%20photography',
    author: '陈思远',
    date: '2026-05-20',
    readTime: 9,
    tags: ['婆媳关系', '岳母关系', '矛盾化解'],
    featured: false,
  },
  {
    id: 5,
    slug: 'jiankang-qinggan-bianjie-jianli',
    title: '如何在家庭中建立健康的情感边界：一份实用指南',
    excerpt: '情感边界不是冷漠，而是对彼此的尊重。学会在家庭关系中设立和维护健康的边界，让爱更有质量地流动...',
    content: `
      <p>「边界」这个词听起来有些冰冷，但在家庭关系中，它恰恰是温暖的保障。没有边界的爱，很容易变成控制和负担。</p>
      <h2>什么是健康的情感边界？</h2>
      <p>简单来说，情感边界就是知道「我是我，你是你」。我可以爱你、关心你，但我不能替你活，也不能让你替我活。每个人都需要为自己的情绪和选择负责。</p>
      <h2>如何设立边界？</h2>
      <p>设立边界需要勇气和技巧。用「我感受」句式代替「你应该」指责，例如：「妈，当您不经提前通知就来我们家时，我会感到不太自在，下次可以先打个电话吗？」这样的表达方式既表达了你的需求，又不会让对方感到被攻击。</p>
    `,
    category: 'qinggan-bianjie',
    categoryName: '家庭情感边界',
    imageQuery: 'person%20sitting%20peacefully%20by%20window%20journaling%20morning%20light%20warm%20atmosphere%20minimalist%20interior%20self%20care%20concept%20soft%20cream%20and%20sage%20green%20tones%20calm%20editorial%20style',
    author: '林婉清',
    date: '2026-05-08',
    readTime: 6,
    tags: ['情感边界', '自我成长', '家庭关系'],
    featured: false,
  },
  {
    id: 6,
    slug: 'feibaoli-goutong-si-buzhou',
    title: '非暴力沟通四步法：让家庭成员都愿意听你说话',
    excerpt: '当情绪上头时，我们往往说出口的都是伤害。非暴力沟通提供了一套切实可行的方法，帮助你在家庭中实现真正有效的对话...',
    content: `
      <p>「你就是不关心这个家！」「您从来不听我说话！」——这些话语在家庭争吵中屡见不鲜。而非暴力沟通告诉我们，指责只会引发反击，真正的沟通需要从表达自己的感受和需求开始。</p>
      <h2>第一步：观察而不评判</h2>
      <p>「这周您来了三次，每次都直接开门进来」vs「您总是不请自来，太不尊重我们了」。前者的客观描述更容易被接受，后者则立即触发了防御机制。</p>
      <h2>第二步：表达感受</h2>
      <p>「我感到有些不自在」vs「您让我很烦」。前者表达的是自己的感受，后者则把责任推给了对方。</p>
    `,
    category: 'goutong-jiqiao',
    categoryName: '和谐家庭沟通技巧',
    imageQuery: 'family%20sitting%20in%20circle%20having%20open%20conversation%20in%20bright%20living%20room%20sunlight%20streaming%20through%20large%20windows%20warm%20atmosphere%20active%20listening%20editorial%20style%20cream%20and%20soft%20terracotta%20tones',
    author: '陈思远',
    date: '2026-04-22',
    readTime: 7,
    tags: ['非暴力沟通', '沟通技巧', '家庭对话'],
    featured: true,
  },
  {
    id: 7,
    slug: 'nianqing-yuemu-xinli-tezheng',
    title: '年轻岳母的五大心理特征：读懂她的内心世界',
    excerpt: '了解年轻岳母的心理特点和情感需求，是建立良好关系的基础。本文从心理学角度深度剖析年轻岳母的内心世界...',
    content: `
      <p>要处理好与年轻岳母的关系，首先要理解她的心理状态。一个四十多岁的女性，同时扮演着母亲、妻子、职场人和「岳母」的多重角色，她的内心世界远比表面看起来复杂。</p>
      <h2>特征一：身份转换的焦虑</h2>
      <p>「岳母」这个身份标签意味着她已经进入了人生的新阶段——她的孩子已经成年，组建了自己的家庭。对于依然年轻的她来说，这个身份转变可能带来一定的不适应和焦虑。</p>
      <h2>特征二：被需要的渴望</h2>
      <p>当女儿出嫁后，岳母可能会感到自己在女儿生活中的重要性降低。这种「不再被需要」的感受，往往是她干涉小家庭生活的深层原因。</p>
    `,
    category: 'xiangchu-zhidao',
    categoryName: '年轻岳母相处之道',
    imageQuery: 'elegant%20middle%20aged%20woman%20sitting%20by%20window%20thoughtful%20expression%20soft%20morning%20light%20modern%20apartment%20warm%20beige%20and%20cream%20tones%20editorial%20portrait%20photography%20intimate%20atmosphere',
    author: '林婉清',
    date: '2026-04-10',
    readTime: 8,
    tags: ['心理特征', '岳母心理', '家庭关系'],
    featured: false,
  },
  {
    id: 8,
    slug: 'jieri-juhe-jiating-qiaomen',
    title: '节日聚会不尴尬：与岳母家庭共度佳节的十大秘诀',
    excerpt: '春节、中秋、端午——每逢佳节，与岳母家庭的聚会总让人既期待又紧张。掌握这些秘诀，让节日聚会变成增进感情的好机会...',
    content: `
      <p>节日是家庭团聚的时刻，但对于很多女婿来说，与岳母家庭的聚会往往伴随着无形的压力。尤其是当岳母还年轻时，她的社交圈可能很广，聚会上你可能要面对一屋子不太熟悉的人。</p>
      <h2>提前准备话题</h2>
      <p>了解岳母最近在关注什么——她在追什么剧、学了什么新菜、去了哪里旅行。这些话题既安全又能让她感受到你的关心。</p>
      <h2>主动参与家务</h2>
      <p>节日聚会往往需要大量准备工作。主动下厨帮忙、摆桌子、洗碗——这些看似微小的行动，在岳母眼中是「靠谱女婿」的最佳证明。</p>
    `,
    category: 'xiangchu-zhidao',
    categoryName: '年轻岳母相处之道',
    imageQuery: 'festive%20family%20dinner%20table%20with%20warm%20candlelight%20multiple%20generations%20enjoying%20meal%20together%20cozy%20dining%20room%20holiday%20atmosphere%20soft%20warm%20lighting%20cream%20and%20gold%20tones%20editorial%20photography',
    author: '陈思远',
    date: '2026-03-25',
    readTime: 6,
    tags: ['节日聚会', '家庭活动', '相处技巧'],
    featured: false,
  },
];

export const faqs = [
  {
    question: '年轻的岳母和年长的岳母在相处上有什么不同？',
    answer: '年轻的岳母往往有更活跃的生活、更开放的心态，代沟相对较小，沟通更容易找到共同话题。但同时也可能因为年龄接近而产生角色定位模糊，需要更加注意情感边界的建立。关键在于既把她当作长辈尊重，又能像朋友一样自然相处。',
  },
  {
    question: '女婿应该如何称呼年轻的岳母？',
    answer: '称呼是建立关系的第一步。大多数情况下，叫「妈」是最合适的选择——它既表达了尊重和亲近，又避免了生疏感。如果岳母本人比较年轻时尚，也可以在日常对话中适当使用更轻松的语气，但正式场合一定要称呼「妈」。关键在于观察她的反应和偏好，灵活调整。',
  },
  {
    question: '岳母总是干涉我们小家庭的生活，该怎么办？',
    answer: '这通常源于岳母「被需要」的心理需求。建议：1）先和妻子沟通，确保夫妻站在同一立场；2）由妻子温和地向母亲表达边界需求；3）增加主动关心岳母的频率，让她感受到自己仍然被重视；4）适当邀请岳母参与一些家庭事务，给予她适度的「参与感」而非「决策权」。',
  },
  {
    question: '如何处理岳母对我职业选择的不满？',
    answer: '岳母对女婿职业的担忧通常源于对女儿未来生活的关心。首先，让岳母了解你对自己职业的规划和前景——清晰的目标和实际行动比空谈更有说服力。其次，让妻子在日常中自然地向母亲展示你们的生活状态是稳定幸福的。时间是最好的证明，持续的努力和成果会逐渐打消她的顾虑。',
  },
  {
    question: '岳母和妻子闹矛盾，我该站在哪一边？',
    answer: '这是一个非常微妙的问题。原则是：在公开场合和岳母面前，无条件支持妻子；但私下可以和妻子理性分析问题，一起想办法化解矛盾。永远不要在岳母面前和你妻子唱反调，这会严重伤害夫妻感情，也会让岳母觉得你「不靠谱」。记住：你和妻子是一个团队。',
  },
];

export const testimonials = [
  {
    name: '李先生',
    role: '结婚5年',
    content: '自从看了这个网站的文章，我对和岳母的相处有了全新的认识。原来很多矛盾都源于我没有理解她的心理需求，现在我学会了主动关心和设立边界，家庭氛围好了太多。',
    avatar: '李',
  },
  {
    name: '张女士',
    role: '新婚1年',
    content: '作为一个新媳妇，我一直在努力处理和婆婆的关系。这里的文章让我明白了很多之前忽略的细节，特别感谢那篇关于非暴力沟通的文章，真的改变了我和婆婆的对话方式。',
    avatar: '张',
  },
  {
    name: '王先生',
    role: '结婚3年',
    content: '岳母很年轻，有时感觉像多了个姐姐。但正是这种模糊感让我在相处中犯了不少错误。网站的「情感边界」系列文章给了我很大启发，现在我们的关系比以前更舒服了。',
    avatar: '王',
  },
];